import { authService } from "@/services/AuthService";
import axios, { AxiosError } from "axios";
import { config as appConfig } from "@/lib/config";

const API_BASE_URL = appConfig.VITE_API_URL;

const axiosInstance = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  withCredentials: true,
});

axiosInstance.interceptors.request.use(async (config) => {
  const token = await authService.getAccessToken();
  const isRelativeUrl = !config.url?.startsWith("http");
  const isIdentityUrl = config.url?.startsWith(appConfig.VITE_IDENTITY_API_URL);
  if (token && (isRelativeUrl || isIdentityUrl)) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error instanceof AxiosError && error.response?.status === 401) {
      authService.login(
        window.location.pathname +
          window.location.search +
          window.location.hash,
      );
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
